import type { ZervantTemplateSettings } from '../../../types/templates/zervantTemplateSettings'
import type { LogoAndBrandingSettingsFormValues } from '../types/logoAndBrandingSettingsFormValues'

type LogoAndBrandingTemplateFormValues = Omit<LogoAndBrandingSettingsFormValues, 'logoId' | 'logoUrl'>

// A missing template or field stays undefined here, and the form defaults fill it in.
export const getLogoAndBrandingTemplateFormValues = (
  documentTemplateSettings?: ZervantTemplateSettings,
): Partial<LogoAndBrandingTemplateFormValues> => ({
  shouldApplyTemplateColorToColumnHeaders: documentTemplateSettings?.areas?.includes('columnHeaders'),
  shouldApplyTemplateColorToDividers: documentTemplateSettings?.areas?.includes('dividers'),
  shouldApplyTemplateColorToHeader: documentTemplateSettings?.areas?.includes('header'),
  shouldApplyTemplateColorToTotal: documentTemplateSettings?.areas?.includes('total'),
  templateColor: documentTemplateSettings?.color?.text,
  templateFont: documentTemplateSettings?.font,
})
